import { render, staticRenderFns } from "./recycleOrder.vue?vue&type=template&id=2e765a12&scoped=true"
import script from "./recycleOrder.vue?vue&type=script&lang=js"
export * from "./recycleOrder.vue?vue&type=script&lang=js"
import style0 from "./recycleOrder.vue?vue&type=style&index=0&id=2e765a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e765a12",
  null
  
)

export default component.exports